import { useTranslation } from 'react-i18next';
import { useMutation } from '@tanstack/react-query';

import { deleteOrganizationComment } from '@/api/v4/organization-comments.api';
import { queryClient, QueryKey } from '@/config/query-client';
import { notify } from '@/ui/snackbar/notify';

import { companyIdState } from '../../company.state';
import { useAtomValue } from 'jotai';

export const useDeleteCompanyComment = () => {
  const { t } = useTranslation('default');
  const companyId = useAtomValue(companyIdState);

  const mutation = useMutation({
    mutationFn: deleteOrganizationComment,
    onError: (error: Error) => {
      notify({
        message: t`unknownError`,
      });
      console.error(error.message);
    },
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: [QueryKey.CompanyComments, companyId],
        }),
        queryClient.invalidateQueries({ queryKey: [QueryKey.LastActivities] }),
        queryClient.invalidateQueries({
          queryKey: [QueryKey.LastActivitiesCount],
        }),
        queryClient.invalidateQueries({
          queryKey: [QueryKey.CompanyActionsInfo],
        }),
      ]);
    },
  });

  return {
    deleteComment: mutation.mutateAsync,
    isError: mutation.isError,
  };
};
